import { graphql } from "msw";
import { CustomerQuery } from "@catchoftheday/common-vendors";
import { Customer } from "@cart-app/generated/graphql";

export const mockCustomer = {
  __typename: "Customer" as const,
  id: "1234",
  displayName: "Joe",
  club: {
    __typename: "ClubCustomerSubscription",
    active: false,
    onFreeTrial: false,
    freeTrialEligible: true,
  },
  email: "joe@catch.com.au",
  addressBook: {
    defaultAddress: {
      id: "address1",
      company: null,
      firstName: "John",
      lastName: "Doe",
      streetAddress: "Unit 3",
      streetAddress2: "1 Rosamond Rd",
      postcode: "3032",
      city: "Maribyrnong",
      country: "Australia",
      state: "Victoria",
      stateShort: "VIC",
      phoneNumber: "0468697867",
      deliveryLocationType: "NORMAL" as const,
      deliveryLocationName: null,
    },
    addresses: [
      {
        id: "address1",
        company: null,
        firstName: "John",
        lastName: "Doe",
        streetAddress: "Unit 3",
        streetAddress2: "1 Rosamond Rd",
        postcode: "3032",
        city: "Maribyrnong",
        country: "Australia",
        state: "Victoria",
        stateShort: "VIC",
        phoneNumber: "0468697867",
        deliveryLocationType: "NORMAL" as const,
        deliveryLocationName: null,
      },
      {
        id: "address2",
        company: "Kmart - Highpoint",
        firstName: "Jane",
        lastName: "Doe",
        streetAddress: "Highpoint shopping center",
        streetAddress2: "2 Tumbolong bvd",
        postcode: "2000",
        city: "Haymarket",
        country: "Australia",
        state: "Victoria",
        stateShort: "VIC",
        phoneNumber: "0418319333",
        deliveryLocationType: "CLICK_AND_COLLECT" as const,
        deliveryLocationName: "Kmart",
      },
    ],
  },
  membership: {
    id: "1",
    linked: true,
    doubleSubscription: false,
    eligibleForMigration: false,
    subscription: {
      active: false,
      freeTrialEligible: true,
      onFreeTrial: true,
    },
  },
};

export const handler = graphql.query<CustomerQuery>(
  "Customer",
  (_req, res, ctx) => {
    return res(
      ctx.data({
        customer: mockCustomer as Customer,
      })
    );
  }
);
